// extracted by mini-css-extract-plugin
module.exports = {"main":"landingpage-module--main--37Xs3","mainHeadding":"landingpage-module--mainHeadding--qHU2b"};